import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { routes } from '@/app/routes';

const routeSuffix = '/:passwordReset?';

/**
 * This component is a wrapper around Route component. Will automatically redirect to
 * landing page if user is already authenticated
 *
 * @param {object} param
 * @param {bool} param.isAuthenticated is logged in or not
 * @param {element | func | string} param.component
 * @param {string} param.path e.g.: /login
 */
export function UnauthenticatedRoute(props) {
  const { isAuthenticated, component, path, location } = props;
  const nextPath = location.state?.from || routes.ROOT;

  return isAuthenticated ? (
    <Redirect to={`${nextPath}`} />
  ) : (
    <Route
      path={path.map((subPath) => `${subPath}${routeSuffix}`)}
      component={component}
    />
  );
}

UnauthenticatedRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  path: PropTypes.array.isRequired,
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.string,
  ]),
};
